ClientVersion = require './client-version'
{ currentLocale } = require '@trello/locale'

module.exports = -> [
  schema: 'iglu:com.trello/web-context/jsonschema/1-0-4',
  data:
    'client_version': ClientVersion.version.toString()
    'client_locale': currentLocale
]



// WEBPACK FOOTER //
// ./app/scripts/debug/get-web-context.coffee